import { render } from "./group-info.vue?vue&type=template&id=08e74930&scoped=true"
import script from "./group-info.vue?vue&type=script&lang=js"
export * from "./group-info.vue?vue&type=script&lang=js"

import "./group-info.vue?vue&type=style&index=0&id=08e74930&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e74930"]])

export default __exports__